/* Shared Trustpilot rating for the home hero, collection cards and AJAX cart drawer. */
(() => {
  if (window.__lbdbCartTrustpilotInitialized) return;
  window.__lbdbCartTrustpilotInitialized = true;

  const drawer = document.getElementById('cart-drawer');
  const hasHero = () => Boolean(document.querySelector('[data-lbdb-trustpilot-hero]'));
  if (!drawer && !hasHero()) return;

  const ENDPOINT = 'https://api.trustpilot.com/v1/business-units/65e5cf0629d80401be50c61e';
  const API_KEY = 'tpk-OnSKJ1jpMpkr5PGR6o8m0XzLmmAo'; // Existing public Trustpilot API key, never the secret.
  const CACHE_KEY = 'lbdb_tp_business_unit_v2';
  const CACHE_TTL = 60 * 60 * 1000;
  const LOCALE = document.documentElement.lang || 'fr';
  const formatCount = new Intl.NumberFormat(LOCALE);
  const formatScore = new Intl.NumberFormat(LOCALE, { minimumFractionDigits: 1, maximumFractionDigits: 1 });
  let rating = null;
  let request = null;
  let renderedLink = null;

  function valid(data) {
    return data && Number.isInteger(data.count) && data.count >= 0 &&
      Number.isFinite(data.score) && data.score >= 0 && data.score <= 5 &&
      Number.isFinite(data.stars) && data.stars >= 0 && data.stars <= 5 &&
      data.stars * 2 === Math.round(data.stars * 2);
  }

  function readCache() {
    try {
      const cached = JSON.parse(localStorage.getItem(CACHE_KEY));
      return cached && Number.isFinite(cached.ts) &&
        Date.now() - cached.ts >= 0 && Date.now() - cached.ts < CACHE_TTL &&
        valid(cached) ? cached : null;
    } catch (_) {
      return null;
    }
  }

  function renderHero(data) {
    if (!valid(data)) return;
    const formattedScore = formatScore.format(data.score);
    document.querySelectorAll('[data-lbdb-trustpilot-hero]').forEach((hero) => {
      const score = hero.querySelector('[data-lbdb-trustpilot-score]');
      if (!score) return;
      score.textContent = formattedScore;
      score.setAttribute('aria-label', `${formattedScore}/5`);
      score.hidden = false;
      const group = hero.querySelector('[data-lbdb-trustpilot-rating]');
      const stars = hero.querySelector('[data-lbdb-trustpilot-stars]');
      const excellent = hero.querySelector('[data-lbdb-trustpilot-excellent]');
      if (group) group.hidden = false;
      if (stars) {
        stars.src = `https://images-static.trustpilot.com/api/stars/${data.stars}/star.svg`;
        stars.hidden = false;
        stars.onerror = () => { stars.hidden = true; };
      }
      if (excellent) excellent.hidden = data.stars < 4.5;
    });
  }

  function render(data) {
    renderHero(data);
    const link = drawer && drawer.querySelector('.lbdb-footer-trustpilot__link');
    if (!link || !valid(data)) return;
    const stars = link.querySelector('.lbdb-footer-trustpilot__stars');
    const score = link.querySelector('.lbdb-footer-trustpilot__score');
    const count = link.querySelector('.lbdb-footer-trustpilot__count');
    const separators = link.querySelectorAll('.lbdb-footer-trustpilot__sep');
    if (!stars || !score || !count || separators.length !== 1) return;

    const formattedScore = formatScore.format(data.score);
    const formattedCount = formatCount.format(data.count);
    const reviewLabel = link.dataset.reviewsLabel || 'reviews';
    stars.hidden = false;
    score.textContent = `${formattedScore}/5`;
    score.hidden = false;
    count.textContent = `${formattedCount} ${reviewLabel}`;
    count.hidden = false;
    separators.forEach((sep) => { sep.hidden = false; });
    const actionLabel = link.dataset.actionLabel || 'Trustpilot';
    link.setAttribute('aria-label', `${actionLabel} · ${formattedScore}/5 · ${formattedCount} ${reviewLabel}`);
  }

  function load() {
    if (rating && !readCache()) rating = null;
    if (rating) { render(rating); return; }
    rating = readCache();
    if (rating) { render(rating); return; }
    if (request) return;

    request = fetch(ENDPOINT, { headers: { apikey: API_KEY } })
      .then((response) => {
        if (!response.ok) throw new Error(`Trustpilot HTTP ${response.status}`);
        return response.json();
      })
      .then((data) => {
        const fresh = {
          count: data.numberOfReviews && data.numberOfReviews.total,
          score: data.score && data.score.trustScore,
          stars: data.score && data.score.stars,
          ts: Date.now()
        };
        if (!valid(fresh)) return;
        rating = fresh;
        try { localStorage.setItem(CACHE_KEY, JSON.stringify(fresh)); } catch (_) { /* storage unavailable */ }
        render(fresh);
      })
      .catch(() => { /* Keep the honest Trustpilot-only link if the API fails. */ })
      .finally(() => { request = null; });
  }

  function refreshIfReplaced() {
    const link = drawer && drawer.querySelector('.lbdb-footer-trustpilot__link');
    if (!link || link === renderedLink) return;
    renderedLink = link;
    load();
  }

  // Facets replace the collection section's children; never observe the whole page.
  const collectionCard = document.querySelector('[data-lbdb-trustpilot-card]');
  const collectionSection = collectionCard && collectionCard.closest('.shopify-section');
  const seenCards = new WeakSet();
  function refreshCollectionCards() {
    if (!collectionSection) return;
    let replaced = false;
    collectionSection.querySelectorAll('[data-lbdb-trustpilot-card]').forEach((card) => {
      if (seenCards.has(card)) return;
      seenCards.add(card);
      replaced = true;
    });
    if (replaced) load();
  }
  if (collectionSection) {
    new MutationObserver(refreshCollectionCards).observe(collectionSection, { childList: true, subtree: true });
    refreshCollectionCards();
  }
  if (drawer) new MutationObserver(refreshIfReplaced).observe(drawer, { childList: true, subtree: true });
  window.addEventListener('pageshow', () => {
    if (rating && (!readCache())) rating = null;
    refreshIfReplaced();
    if (renderedLink || hasHero()) load();
  });
  refreshIfReplaced();
  if (hasHero()) load();
})();
